export default __webpack_public_path__ + "static/media/Travel-header.0dc743fd.png";